module.exports = __webpack_public_path__ + "img/blog.0873cf60.png";